import React, { useEffect, useState } from "react";
import Fab from "@mui/material/Fab";
import { KeyboardArrowUp as KeyboardArrowUpIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";

const ScrollButton = () => {
  const theme = useTheme();
  const [showScroll, setShowScroll] = useState(false);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 300) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 300) {
      setShowScroll(false); //faseにすること
    }
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", checkScrollTop);
    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScroll]);

  return (
    <>
      {showScroll && (
        <Box
          sx={{
            position: "fixed",
            top: "calc(100vh - 100px)",
            left: "calc(1024px + calc(calc(100vw - 1280px) / 2))",
            [theme.breakpoints.down("md")]: {
              top: "calc(100vh - 100px)",
              left: "calc(100vw - 100px)",
            },
            [theme.breakpoints.down("sm")]: {
              top: "calc(100vh - 50px)",
              left: "calc(100vw - 80px)",
            },
          }}
        >
          <Fab color="primary" size="small" onClick={scrollTop}>
            <KeyboardArrowUpIcon sx={{ color: "#004c89" }} />
          </Fab>
        </Box>
      )}
    </>
  );
};

export default ScrollButton;
